export default __webpack_public_path__ + "static/media/vc3.f46c3ef9.jpg";